import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../bl-dialog.action';
import { BlDialogState } from '../bl-dialog.state';

import { Reload, ReloadResult } from './reload.action';

export function reloadReducer(
    state: BlDialogState,
    action: PayloadAction<ActionType.COACHING__BL__RELOAD, Reload>,
): BlDialogState {
    return {
        ...state,
    };
}

export function reloadResultReducer(
    state: BlDialogState,
    action: PayloadAction<ActionType.COACHING__BL__RELOAD_RESULT, ReloadResult>,
): BlDialogState {
    try {
        return {
            ...state,
            behaviours: action.payload.behaviours,
            subBehaviours: action.payload.subBehaviours,
            focuses: action.payload.focuses,
        };
    } catch {
        return state;
    }
}
